import React, {useState, useEffect} from 'react';
import { useAuth } from '../context/AuthContextOld';
import UtilisateurList from '../components/UtilisateurList';
import { getUtilisateurs } from '../services/api';

const AccueilAdmin = () => {
    const { user, logout } = useAuth();

    const [utilisateurs, setUtilisateurs] = useState([]);

    
    useEffect(() => {
        const fetchUtilisateurs = async () => {
            try {
                const response = await getUtilisateurs();
                setUtilisateurs(response.data.member);
            } catch (error) {
                console.error('Error fetching Utilisateurs:', error);
            }
        };
    
        fetchUtilisateurs();
    }, []);

    if (!user) {
        return <p>Chargement...</p>;
    }


    return (
        <div>
            <h1>Bienvenue, {user.username}</h1>
            <>
                <UtilisateurList utilisateurs={utilisateurs}/>
            </>
            <button onClick={logout}>Déconnexion</button>
        </div>
    );
};

export default AccueilAdmin;
